import initApp from './common';
import SafeMarketData from '../components/SafeGenerator/SafeMarketData';

initApp(SafeMarketData, { root: 'safe-market-data-root' });
